import {
	HOCLayout,
	PreDrawResultsBar,
	PreDrawSaveBar,
	PreRegistration,
} from "apps/DRAW_PREDICTOR/components";
import React, {useEffect} from "react";
import styled from "styled-components";
import {ReactComponent as Logo} from "apps/DRAW_PREDICTOR/assets/images/logoFooter.svg";
// import footerBg from "apps/DRAW_PREDICTOR/assets/images/footerBG.jpg";
import bg from "apps/DRAW_PREDICTOR/assets/images/bgPattern.png";
import rightCorner from "apps/DRAW_PREDICTOR/assets/images/background/rightCorner.svg";
import leftCorner from "apps/DRAW_PREDICTOR/assets/images/background/leftCorner.svg";
import {PreDrawCards} from "apps/DRAW_PREDICTOR/pages/preDraw/PreDrawCards";
import {media} from "assets/css/media";
import {useDispatch, useSelector} from "react-redux";
import {
	fetchQualifierGroupsJSON,
	fetchQualifierSquadsJSON,
} from "apps/DRAW_PREDICTOR/modules/actions";
import {isPreDrawSaved, isQualifierJSONsReceived} from "apps/DRAW_PREDICTOR/modules/selectors";
import {PagePreloader} from "components";
import {PreDrawResults} from "apps/DRAW_PREDICTOR/pages/preDraw/PreDrawResults";
import {trackAdobeAnalytics} from "modules";

const Wrapper = styled.div`
	width: 100%;
	background: url(${bg}) top center, linear-gradient(180deg, #8a1538 0%, #d20a46 98.01%);
	background-repeat: no-repeat;
	background-size: 100% auto;
	overflow: hidden;
	position: relative;
	.qatar-logo {
		width: 50%;
		margin: 50px auto;
		display: block;
	}
`;
const Inner = styled.div`
	min-height: 600px;
	max-width: 1360px;
	padding: 20px;
	margin: 0 auto;
	@media (max-width: ${media.mobile}) {
		min-height: 100%;
		padding: 0;
	}
`;

const Footer = styled.footer`
	background: url(${rightCorner}) bottom right, url(${leftCorner}) bottom left;
	background-repeat: no-repeat;
	background-size: contain;
	position: absolute;
	width: 100%;
	height: 250px;
	bottom: 0;
	@media (max-width: ${media.mobile}) {
		height: 100px;
	}
`;

export const PreDraw: React.FC = () => {
	const dispatch = useDispatch();
	const isLoaded = useSelector(isQualifierJSONsReceived);
	const showResult = useSelector(isPreDrawSaved);

	useEffect(() => {
		trackAdobeAnalytics({
			section: "",
		});
	}, []);

	useEffect(() => {
		dispatch(fetchQualifierGroupsJSON());
		dispatch(fetchQualifierSquadsJSON());
	}, [dispatch]);

	if (!isLoaded) {
		return <PagePreloader />;
	}
	const props = showResult
		? {
				title: "review.page.header",
				subTitle: "review.page.copy",
		  }
		: {
				title: "landing.page.header",
				subTitle: "prediction.page.qualifying_description",
		  };

	return (
		<HOCLayout>
			<Wrapper>
				<Inner>
					<PreRegistration {...props} />
					{showResult ? <PreDrawResults /> : <PreDrawCards />}
				</Inner>
				<Logo className="qatar-logo" />
				<Footer />
			</Wrapper>
			{showResult ? <PreDrawResultsBar /> : <PreDrawSaveBar />}
		</HOCLayout>
	);
};

export default PreDraw;
